import React from 'react';
import { TEXT_KEYS } from '../../../constants/textKeys';
import { useIsMobile } from '../../../hooks/useIsMobile';
import IMAGES_PATH from '../../../Images';
import { t } from '../../../translation/translation';
import { Button } from '../../common/Button';
import MozaicItem from '../../common/MozaicItem';
import './style.css';
import { useNavigation } from '../../../hooks/useNavigate';

const rows = [
    [
        {
            titleKey: TEXT_KEYS.HOME_MOZAIC_ITEM_TITLE_1,
            descriptionKey: TEXT_KEYS.HOME_MOZAIC_ITEM_DESCRIPTION_1,
            image: IMAGES_PATH.IMAGE_HOME_FUTURE_1,
            isSquare: false,
        },
        {
            titleKey: TEXT_KEYS.HOME_MOZAIC_ITEM_TITLE_2,
            descriptionKey: TEXT_KEYS.HOME_MOZAIC_ITEM_DESCRIPTION_2,
            image: IMAGES_PATH.IMAGE_HOME_FUTURE_2,
            isSquare: true,
        },
    ],
    [
        {
            titleKey: TEXT_KEYS.HOME_MOZAIC_ITEM_TITLE_3,
            descriptionKey: TEXT_KEYS.HOME_MOZAIC_ITEM_DESCRIPTION_3,
            image: IMAGES_PATH.IMAGE_HOME_FUTURE_3,
            isSquare: true,
        },
        {
            titleKey: TEXT_KEYS.HOME_MOZAIC_ITEM_TITLE_4,
            descriptionKey: TEXT_KEYS.HOME_MOZAIC_ITEM_DESCRIPTION_4,
            image: IMAGES_PATH.IMAGE_HOME_FUTURE_4,
            isSquare: false,
        },
    ],
    [
        {
            titleKey: TEXT_KEYS.HOME_MOZAIC_ITEM_TITLE_5,
            descriptionKey: TEXT_KEYS.HOME_MOZAIC_ITEM_DESCRIPTION_5,
            image: IMAGES_PATH.IMAGE_HOME_FUTURE_5,
            isSquare: true,
        },
        {
            titleKey: TEXT_KEYS.HOME_MOZAIC_ITEM_TITLE_6,
            descriptionKey: TEXT_KEYS.HOME_MOZAIC_ITEM_DESCRIPTION_6,
            image: IMAGES_PATH.IMAGE_HOME_FUTURE_6,
            isSquare: true,
        },
        {
            titleKey: TEXT_KEYS.HOME_MOZAIC_ITEM_TITLE_7,
            descriptionKey: TEXT_KEYS.HOME_MOZAIC_ITEM_DESCRIPTION_7,
            image: IMAGES_PATH.IMAGE_HOME_FUTURE_7,
            isSquare: true,
        },
    ],
];

export const SectionMozaic = () => {

    const isMobile = useIsMobile()

    const {
        goToMission,
    } = useNavigation();

    return (
        <div className='section'>
            <div className='section-mozaic-header'>
                <h4 className='section-mozaic-header-subtitle'>{t(TEXT_KEYS.HOME_MOZAIC_SUBTITLE)}</h4>
                <h1>
                    {t(TEXT_KEYS.HOME_MOZAIC_TITLE_1)}{' '}
                    <h1 className='text-blue section-mozaic-header-title'>{t(TEXT_KEYS.HOME_MOZAIC_TITLE_2)}</h1>
                </h1>
            </div>
            <div className='section-mozaic-container'>
                {!isMobile && rows.map((row, rowIndex) => (
                    <div key={rowIndex} className='section-mozaic-row'>
                        {row.map((item, itemIndex) => (
                            <MozaicItem
                                key={itemIndex}
                                titleKey={item.titleKey}
                                descriptionKey={item.descriptionKey}
                                image={item.image}
                                isSquare={item.isSquare}
                            />
                        ))}
                    </div>
                ))}
            </div>
            <div className='section-mozaic-container-mobile'>
                {isMobile &&
                    rows.flat().map((item, index) => (
                        <div className='section-mozaic-item-container' key={index}>
                            <MozaicItem
                                key={index}
                                titleKey={item.titleKey}
                                descriptionKey={item.descriptionKey}
                                image={item.image}
                                isSquare={true}
                            />
                        </div>
                    ))}
            </div>
            <div className='section-mozaic-button'>
                <Button
                    label={t(TEXT_KEYS.HOME_BLUE_CARTEL_BUTTON)}
                    onClick={goToMission}
                />
            </div>
        </div>
    );
};

export default SectionMozaic;
